export default __webpack_public_path__ + "static/media/manual-preview.3f0ee2b6.png";